import { Col, Row, Spinner, Alert } from "react-bootstrap";
import TrackingID from "./TrackingID";
import RecentOrders from "./RecentOrders";
import OrderSummary from "./OrderSummary";
import BillingDetails from "./BillingDetails";
import ShippingDetails from "./ShippingDetails";
import DeliveryDetails from "./DeliveryDetails";
import { useOrderDetails } from "../hooks/use-order-details";
import { useParams } from "react-router-dom";



const OrderDetails = () => {
    // Obtener el ID de la orden de los parámetros de la URL
    const { id } = useParams<{ id: string }>();
    
    // Usar el hook personalizado para obtener los detalles de la orden
    const { order, isLoading, isError, error } = useOrderDetails(id);
    
    // Mostrar estado de carga
    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center p-5">
                <Spinner animation="border" variant="primary" />
                <span className="ms-2">Cargando detalles de la orden...</span>
            </div>
        );
    }
    
    // Mostrar error si ocurre
    if (isError) {
        return (
            <Alert variant="danger" className="m-4">
                Error al cargar los detalles de la orden: {error?.message || 'Error desconocido'}
            </Alert>
        );
    }
    
    // Mostrar mensaje si no se encuentra la orden
    if (!order) {
        return (
            <Alert variant="warning" className="m-4">
                No se encontró la orden solicitada.
            </Alert>
        );
    }
    
    return (
        <div>
            <Row>
                <Col lg={7} xxl={8}>
                    <TrackingID order={order} />
                    <RecentOrders order={order}/>
                </Col>

                <Col lg={5} xxl={4}>
                    <OrderSummary order={order} />
                </Col>
            </Row>

            <Row>
                <Col md={6} xl={6} xxl={4}>
                    <BillingDetails order={order} />
                </Col>

                {order?.address_id&&(
                    <Col md={6} xl={6} xxl={4}>
                        <ShippingDetails order={order} />
                    </Col>
                )}
               

                <Col md={6} xl={6} xxl={4}>
                    <DeliveryDetails order={order} />
                </Col>
            </Row>
        </div>
    );
};

export default OrderDetails;